module.exports = __webpack_public_path__ + "img/bank-payment.6779430a.png";